import { metrics } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function Metrics() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-foreground-950">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="结果展示"
          title="让活动效果看得见"
          subtitle="活动数据实时呈现，主办方随时掌握发放与核销动态。"
          dark
        />

        <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-4">
          {metrics.map((item, idx) => (
            <Reveal key={item.label} delay={idx * 80}>
              <div className="h-full p-5 md:p-6 rounded-lg bg-background-50/5 border border-background-50/10 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-500/15 text-secondary-300">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="mt-4 text-2xl md:text-3xl font-bold text-background-50 font-heading">
                  {item.value}
                  {item.value !== '—' && (
                    <span className="ml-0.5 text-sm font-normal text-foreground-400">{item.unit}</span>
                  )}
                </div>
                <div className="mt-1 text-xs md:text-sm text-foreground-300 whitespace-nowrap">
                  {item.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-foreground-400">
          以上为「活动数据实时呈现」界面示意，真实案例数据经确认后将在此展示。
        </p>
      </div>
    </section>
  );
}